module.exports = __webpack_public_path__ + "static/faizan-8fbe7742f71961674c3aa673fbeb602c.png";